import React from "react";
import styles from "./Section8.module.scss";

export const Section8 = function () {
  return (
    <section id="testimonial-section" className={`${styles.container} cc--component-container`}>
      <section className={styles.content}>
        <span className={styles.testimonial}>
          “This is one of the most challenging and yet rewarding courses I have ever completed. This is an excellent
          program for individuals who are thinking about starting a career in cybersecurity. It is equally great for
          those, like me, who have been in this field for quite a while. The program is well designed to evoke deep
          thoughts and discussions about the application of cybersecurity principles in real life to reduce or mitigate
          risk in a complex and interconnected world. Besides, the course provided an avenue for increased networking
          with like-minded cybersecurity professionals around the world.”
        </span>
        <span className={`${styles.source} title`}>
          — Bob Fabien Zinga,
          <br />
          <small>
            <em>Head of Security & IT, Directly; Information Warfare Officer, US Navy Reserve</em>
          </small>
        </span>
      </section>
    </section>
  );
};
